import axiosInstance from "../../../utils/axios";
import {
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  GET_ERRORS,
  REDIRECT,
  GET_ORDER,
  GET_ORDERS,
} from "../actions/types";
import { tokenConfig } from "./auth";

export const createOrder =
  ({ inputData }) =>
  (dispatch, getState) => {
    const data = JSON.stringify({
      data: inputData,
    });

    axiosInstance
      .post("orders", data, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: ORDER_CREATE_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: ORDER_CREATE_FAIL,
        });
        dispatch({
          type: GET_ERRORS,
          payload: err.response,
        });
      });
  };

export const getOrder =
  ({ id }) =>
  (dispatch, getState) => {
    axiosInstance
      .get(`orders/${id}`, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: GET_ORDER,
          payload: res.data.data.attributes,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_ERRORS,
          payload: err.response,
        });
      });
  };

export const getOrders = () => (dispatch, getState) => {
  axiosInstance
    .get("orders?populate=*", tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: GET_ORDERS,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response,
      });
    });
};

export const redirect = () => (dispatch) => {
  dispatch({
    type: REDIRECT,
    payload: null,
  });
};
